import { useEffect, useState } from "react";

const links = [
  { href: "#about", label: "About" },
  { href: "#portfolio", label: "Portfolio" },
  { href: "https://aiglnewcareer.com/franchise-opportunity", label: "Franchise", external: true },
  { href: "#contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[hsl(var(--ivory))]/85 backdrop-blur-md border-b border-[hsl(var(--line))]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="logo-link">
          <img
            src="https://customer-assets.emergentagent.com/job_renewable-invest/artifacts/a94nmrrk_AIGL%20rebranded%20logo%202026.png"
            alt="AIGL — ASELU Investment Growth Limited"
            className="h-12 w-12 object-contain"
          />
          <div className="leading-tight">
            <div className="font-display text-xl font-bold tracking-tight">AIGL</div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-[hsl(var(--fg-muted))]">
              ASELU Investment Growth
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm font-medium text-[hsl(var(--fg))] hover:text-[hsl(var(--terracotta))] transition-colors relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[hsl(var(--terracotta))] transition-all group-hover:w-full"></span>
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a href="#contact" className="btn-pill btn-primary" data-testid="cta-invest-nav">
            Invest with us
            <i className="fa-solid fa-arrow-right text-xs"></i>
          </a>
        </div>

        <button
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 inline-flex items-center justify-center rounded-full border border-[hsl(var(--line))]"
          data-testid="mobile-menu-toggle"
        >
          <i className={`fa-solid ${open ? "fa-xmark" : "fa-bars"}`}></i>
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[hsl(var(--ivory))] border-t border-[hsl(var(--line))]" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                onClick={() => setOpen(false)}
                className="py-2 text-base font-medium"
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a href="#contact" onClick={() => setOpen(false)} className="btn-pill btn-primary justify-center mt-2">
              Invest with us
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
